export default function (key) {
  const config_element = document.getElementById('pb-config');

  if (!config_element) {
    console.warn('Missing config element "pb-config", unable to get config items');

    return null;
  }

  const config = JSON.parse(config_element.innerHTML);

  if (config && config[key]) {
    return config[key];
  }

  return null;
}
